<rask-page pageTitle="Regelverk viol 3" noPadding>
    <rask-container-block>
        <rask-tabs parameterName="section" layout="parent" [size]="4" [wrap]="true">

            <rask-tab #section1 label="Redovisningshanvisning" routeId="section1">
                @if(section1.visited){
                <rask-redovisningshanvisning-search [mottagningsplatsnummer]="mottagningsplatsnummer"
                    [inmatningshandelssortiment]="inmatningshandelssortiment">
                </rask-redovisningshanvisning-search>
                }
            </rask-tab>
            <rask-tab #section2 label="Mätinformation" routeId="section2">
                @if(section2.visited){
                <rask-matinfo-search></rask-matinfo-search>
                }

            </rask-tab>
        </rask-tabs>
    </rask-container-block>
</rask-page>